<template>
  <div class="content content--toggle">
    <div class="text">
      <slot name="title" :title="label">
        <span>{{ label }}</span>
      </slot>
      <span v-if="secondLabel" class="secondary">{{ secondLabel }}</span>
    </div>
    <div class="toggle">
      <input
        class="tgl tgl-light"
        :id="checkboxId"
        type="checkbox"
        v-model="checkboxState"
        v-on:change="valueChanged"
      />
      <label class="tgl-btn" :for="checkboxId"></label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cwToggle',
  props: {
    label: {
      type: String,
      default: ''
    },
    secondLabel: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkboxId: 'cb_' + Math.floor(100 + Math.random() * 900),
      checkboxState: false
    };
  },
  mounted() {
    this.checkboxState = this.value;
  },
  computed: {
    checkboxVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.checkboxState = val;
      }
    }
  },
  methods: {
    valueChanged() {
      this.$emit('toggleChanged', this.checkboxState);
    }
  },
  watch: {
    value(newVal) {
      this.checkboxState = newVal;
    }
  }
};
</script>

<style scoped lang="scss">
.tgl {
  display: none;
  &,
  &:after,
  &:before,
  & *,
  & *:after,
  & *:before,
  & + .tgl-btn {
    box-sizing: border-box;
    &::selection {
      background: none;
    }
  }

  + .tgl-btn {
    outline: 0;
    display: block;
    width: 32px;
    height: 16px;
    position: relative;
    cursor: pointer;
    user-select: none;
    &:after,
    &:before {
      position: relative;
      display: block;
      content: '';
      width: 50%;
      height: 100%;
    }

    &:after {
      left: 0;
    }

    &:before {
      display: none;
    }
  }

  &:checked + .tgl-btn:after {
    left: 50%;
  }
}

.tgl-light {
  + .tgl-btn {
    background-color: $cloudy-blue;
    border-radius: 100px;
    padding: 1px;
    transition: all 0.4s ease;
    &:after {
      border-radius: 50%;
      background: $white;
      transition: all 0.2s ease;
    }
  }

  &:checked + .tgl-btn {
    background: $greeny-blue;
  }
}

.content {
  min-height: 60px;
  margin-right: 16px;
  background: $white;
  display: flex;
  align-items: center;

  .text {
    span ~ span {
      line-height: 1;
    }

    span {
      @include siblings-by-count(2, &) {
        line-height: 1;
        margin: 8px 0 5px;
      }
    }
  }

  span {
    font-size: 14px;
    color: $petrol;
    display: block;
    line-height: 1.5;

    & ~ span {
      clear: left;
      color: $bluey-grey;
    }
  }

  &--dark {
    background: $cloudy-blue-20;

    span {
      font-size: 13px;
      line-height: 1.38;
      color: $bluey-grey;
    }
  }

  &--toggle {
    > *:not(span) {
      display: inline-block;
    }
    span {
      float: left;
      padding-right: 4px;
    }
    .toggle {
      float: right;
      justify-self: auto;
      margin-left: auto;
    }
  }
}
</style>
